<div class="scrollable-container" #scrollableContainer [class.mobile]="!windowService.isDesktopRes">
  <div class="calendar">
    <div class="calendar-days">
      <!-- Property header column -->
      <div class="calendar-header fixed-header property-header" [class.mobile-width]="!windowService.isDesktopRes">
      </div>

      <!-- Time slot headers -->
      @for (timeSlot of timeSlots; track timeSlot) {
        <div
          class="calendar-header fixed-header"
          [class.current-time-column]="properties[0]?.timeSlotData[timeSlot]?.isCurrentTime">
          <div class="header-div">
            <div class="day-header-wrapper" [class.current-time-header]="properties[0]?.timeSlotData[timeSlot]?.isCurrentTime">
              <!-- Anchor element for scrolling -->
              <div [id]="properties[0]?.timeSlotData[timeSlot]?.anchorId" class="time-slot-anchor"></div>
              <tidy-text
                [header]="timeSlot"
                class="time-slot-header" />
            </div>
          </div>
        </div>
      }

      <!-- Property rows with time slots -->
      @for (property of properties; track trackByFn($index, property)) {
        <!-- Property name cell -->
        <div
          class="calendar-day property-col fixed-column"
          [class.mobile-width]="!windowService.isDesktopRes"
          [attr.data-job-count]="property.jobCountForDay"
          [attr.data-has-reservation]="property.hasReservationForDay">
          <tidy-row class="vertical-align-middle">
            <tidy-tag
              [color]="property?.color"
              [addressId]="property?.id"
              style="margin-right: 5px" />
            @if (windowService.isDesktopRes) {
              <tidy-text
                [clickableHeader]="property?.name || property.address"
                (action)="emitClickAction('property', property)"
                [darkHover]="true" />
            }
            @if (!windowService.isDesktopRes) {
              <tidy-text
                [clickableBody]="property?.name || property.address"
                (action)="emitClickAction('property', property)"
                [darkHover]="true" />
            }
          </tidy-row>
          @if (property.inquiriesCount) {
            <tidy-row>
              <button
                type="button"
                class="day-view-inquiries-callout"
                (click)="emitClickAction('inquiries', property)">
                <span class="day-view-inquiries-icon"></span>
                <span class="day-view-inquiries-label">{{ property.inquiriesCount }} {{ property.inquiriesCount === 1 ? 'inquiry' : 'inquiries' }}</span>
              </button>
            </tidy-row>
          }
          @if (property.nextReservationDate) {
            <tidy-row>
              <tidy-text
                [body]="'Next Check In:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="property.nextReservationDateFormatted" />
                @if (property.nextReservationDate === today) {
                  <span>&nbsp;</span>
                  <tidy-text
                    [body]="'(Today)'"
                    class="next-date-text" />
                }
              </tidy-row>
            }
            @if (property.nextJobDate) {
              <tidy-row>
                <tidy-text
                  class="next-date-text"
                  [body]="'Next Job:'" /><span>&nbsp;</span>
                  <tidy-text
                    class="next-date-text"
                    [body]="property.nextJobDateFormatted" />
                  @if (property.nextJobDate === today) {
                    <span>&nbsp;</span>
                    <tidy-text
                      class="next-date-text"
                      [body]="'(Today)'" />
                  }
                </tidy-row>
              }
            </div>
            <!-- Time slot cells -->
            @for (timeSlot of timeSlots; track timeSlot) {
              <div
                (click)="goToBookJob(timeSlot, property)"
                [class]="(property.timeSlotData[timeSlot]?.isCurrentTime ? 'calendar-day current-time' : 'calendar-day') + ' cell-highlight'"
                >

                 <!-- Reservations at this time slot -->
                  @if (property.timeSlotData[timeSlot]?.hasReservation) {
                    @for (reservation of property.timeSlotData[timeSlot]?.reservations; track trackByFn($index, reservation)) {
                      <div
                        class="card-container reservation-card-container"
                        [style]="getReservationCardStyle(reservation, timeSlot)">
                        <app-reservation-card
                          [reservation]="reservation"
                          [address]="property?.displayName"
                          [addressId]="property?.id"
                          size="md" />
                      </div>
                    }
                  }

                <!-- Jobs at this time slot -->
                @if (property.timeSlotData[timeSlot]?.hasJob) {
                  @for (job of property.timeSlotData[timeSlot]?.jobs; track trackByFn($index, job)) {
                    <div
                      class="card-container job-card-container"
                      [ngClass]="job.classes"
                      [style]="'width: ' + job.width + '%;'"
                      (click)="emitClickAction('event', property, 'jobs', job); $event.stopPropagation()">
                      <tidy-card>
                        <div class="event-card-content job-card-content vertical-align-center">
                          <div class="job-icon">
                            <tidy-image
                              [src]="job?.icon" />
                          </div>
                          <div class="job-info">
                            <div class="job-title-left">
                              <tidy-text
                                class="no-wrap job-title"
                                [body]="(job?.title || job?.serviceCategory) | titlecase | truncate:22:false" />
                            </div>
                            <div class="job-title-right">
                              <!-- Time information -->
                              <div class="job-time">
                                @if (!job?.isJobRequest) {
                                  <tidy-text
                                    [body]="job?.time" />
                                }
                                @if (job?.isJobRequest) {
                                  @if (job?.booking?.startDateNoEarlierThan !== job?.booking?.endDateNoLaterThan) {
                                    <tidy-text
                                      [body]="job?.booking?.startDateNoEarlierThan | parseDateTime: 'MMM d'" />
                                    }<span>&nbsp;</span>
                                    <tidy-text
                                      [body]="job?.booking?.startTimeNoEarlierThan" /><span>&nbsp;</span>
                                      <tidy-text
                                        [body]="'-'" />
                                      @if (job?.booking?.startDateNoEarlierThan !== job?.booking?.endDateNoLaterThan) {
                                        <span>&nbsp;</span>
                                        <tidy-text
                                          [body]="job?.booking?.endDateNoLaterThan | parseDateTime: 'MMM d'" />
                                        }<span>&nbsp;</span>
                                        <tidy-text
                                          [body]="(job?.booking?.startDateNoEarlierThan !== job?.booking?.endDateNoLaterThan ? (job?.booking?.endTimeNoLaterThan | translate) : (job?.booking?.endTimeNoLaterThan | truncate:16 | translate))" />
                                      }
                                    </div>
                                    <!-- Status information -->
                                    <div class="job-status">
                                      @if (!job?.isJobRequest) {
                                        @if (job?.status?.icon_type === 'image') {
                                          <tidy-image
                                            [src]="job?.status?.icon"
                                            [class]="job?.status?.class"
                                            style="height: 15px" />
                                        }
                                        @if (job?.status?.icon_type === 'initials') {
                                          <div
                                            [ngClass]="job?.status?.class"
                                            [ngStyle]="job?.status?.status === 'on_the_way' || job?.status?.status === 'arrived_at_home' ? {'margin-right': '8px'} : {}"
                                            [style.background]="util.getAvatarGradient(job?.homekeeperName || 'BA')">
                                            {{(job?.homekeeperName || 'BA') | uppercase}}
                                          </div>
                                        }
                                        <tidy-text
                                          [ngStyle]="{'margin-left': job?.status?.class === 'pro-initials-in-progress' ? '5px' : '0px'}"
                                          [body]="job?.status?.name | titlecase" />
                                      }
                                      @if (job?.isJobRequest) {
                                        @if (job?.status?.icon_type !== 'initials') {
                                          <tidy-image
                                            [src]="job?.status?.icon"
                                            [ngClass]="job?.status?.class ? job?.status?.class : ''"
                                            style="height: 15px" />
                                        }
                                        @if (job?.status?.icon_type === 'initials') {
                                          <div
                                            [ngClass]="job?.status?.class"
                                            [ngStyle]="job?.status?.status === 'on_the_way' || job?.status?.status === 'arrived_at_home' ? {'margin-right': '8px'} : {}"
                                            [style.background]="util.getAvatarGradient(job?.status?.initials || 'BA')">
                                            {{job?.status?.initials | uppercase}}
                                          </div>
                                        }
                                        <tidy-text
                                          [ngStyle]="{'margin-left': job?.status?.class === 'pro-initials-in-progress' ? '5px' : '0px'}"
                                          [body]="job?.status?.name | titlecase" />
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </tidy-card>
                          </div>
                        }
                      }
                      <!-- Add job button -->
                      <div class="add-job-button">
                        <tidy-round-button
                          [buttonWidth]="25"
                          [imageWidth]="10"
                          class="green"
                          [image]="'assets/svg/add-heavy.svg'"
                          (action)="goToBookJob(timeSlot, property)" />
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
